@if (variation === 'checkbox') {
  <mat-checkbox [ngModelOptions]="{standalone: true}" [(ngModel)]="whbChecked"
    (change)="saveMedigapDataToState( whbChecked )">
    {{ whbCheckboxLabel || 'Add Whole Health Balance to My Medigap Plan' }} <span class="material-symbols-outlined" aria-hidden="false"
    aria-label="checkbox tooltip"
    matTooltip="{{whbCheckboxTooltip || 'Checking this will show plans with Whole Health Balance' }}">info
  </span>
</mat-checkbox>
}


@if (variation === 'radio') {
  <mat-label>{{whbCheckboxLabel || 'Add Whole Health Balance to My Medigap Plan'}}<span style="color: #a71919;">*</span>
</mat-label> <br />
@if (variation === 'radio') {
  <mat-radio-group [ngModelOptions]="{standalone: true}" [(ngModel)]="whbChecked"
    (change)="saveMedigapDataToState( whbChecked )" required='true'>
    <mat-radio-button checked value="true">Yes</mat-radio-button>
    <mat-radio-button value="false">No</mat-radio-button>
  </mat-radio-group>
}
}
